<template>
  <div class="" style="width: 100%;">
    <v-container>
      <v-row>
        <v-col class='d-flex flex-row align-center'>
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          <h1>{{this.singular}} #{{ this.data.id }} <span v-if="this.data.name">:</span> {{this.data.name}}</h1>
          <v-chip class="ml-3">{{ helpers.parseSpecialOrderStatus(data.status) }}</v-chip>
          <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-card outlined style="background-color: rgba(0,0,0,0);">
            <v-card-title v-if="data.customerId">
              {{data.customerName}}
            </v-card-title>
            <v-card-subtitle> {{data.customerPhone}}</v-card-subtitle>
            <v-card-text v-if="!data.customerId">
              <v-text-field
                label="Customer"
                outlined
                dense
                v-model="customerSearchField.name"
                :loading="customerSearchField.loading"
                @keydown="searchCustomers('name')"
              />
              <v-text-field
                label="Phone"
                outlined
                dense
                v-model="customerSearchField.phone"
                @keydown="searchCustomers('phone')"
              />   
              <div v-if="customerResults.length>0" class="d-flex flex-column" style="height: 350px;">
                <div @click="selectCustomer(result.id)" class="mb-1 mr-2" style="width: 250px;" v-for="(result, index) of customerResults" :key="index">
                  <v-chip>{{ result.fullName }} | {{ result.phone }}</v-chip>
                </div>
              </div>     
            </v-card-text>
            <v-card-actions>
              <v-btn v-if="!data.customerId" @click="createCustomer" color='success'>Create</v-btn>
              <v-btn @click="clearCustomerSearches" color='info'>Clear</v-btn>
            </v-card-actions>
          </v-card>
          <h3 class="mt-2">Wedding Date</h3>    
          <v-date-picker dense style=" width: 100%;" label="Date Due" class="mb-4 mt-3" @change="updateDueDate()" v-model="data.dueAt" color="info"></v-date-picker>
        </v-col>
        <v-col cols="8">
          <span v-if="data.customerId">
            <h2>Create Item</h2>
            <div style="border:1px solid grey; border-radius: 7px; padding: 15px;" class="d-flex flex-column align-baseline justify-space-between mb-2">
                <div class="d-flex flex-row align-baseline justify-space-between mb-2">
                  <span class="d-flex flex-column">
                    <div>
                      <v-autocomplete
                        :items="assets"
                        :item-text="x => x.styleNo"
                        item-value="id"
                        label="Style"
                        dense
                        clearable
                        outlined
                        id="assetAutocorrect"
                        v-model="newItem.id"  
                        @change="updateStyleNo"
                      >
                      <template v-slot:no-data>
                        <v-btn text block @click="createAsset"><v-icon left>mdi-plus</v-icon>Create Asset</v-btn>
                      </template>
                      </v-autocomplete>
                      <v-text-field
                        label="Colour"
                        outlined
                        dense
                        style="margin-top: -15px;"
                        v-model="newItem.colour"
                      /> 
                      <v-text-field
                        label="Size"
                        outlined
                        dense
                        style="margin-top: -15px;"
                        v-model="newItem.size"
                      />  
                    </div>
                  </span> 
                  <div class="ml-2">
                    <div v-if="newItem.id && !newItem.assetSupplier" class="d-flex flex-row">
                      <v-autocomplete
                        :items="suppliers"
                        :item-text="x => x.name"
                        item-value="id"
                        label="Link Supplier"
                        style="margin-bottom: 11px;"
                        dense
                        clearable
                        hide-details
                        outlined
                        id="supplierAssetAutocorrect"
                        v-model="newItem.supplierId"  
                      >
                        <template v-slot:no-data>
                            <v-btn text block @click="createLinkSupplierNewAsset"><v-icon left>mdi-plus</v-icon>Create Supplier</v-btn>
                        </template>
                      </v-autocomplete>
                      <v-btn class="ml-2" fab color="success" x-small @click="linkSupplierNewAsset"><v-icon>mdi-content-save</v-icon></v-btn>
                    </div>
                    <!-- <div v-if="newItem.id && newItem.assetSupplier">
                      {{newItem.assetSupplier}}
                    </div> -->
                    <v-select
                      :items="getLocations"
                      item-value="id"
                      item-text="name"
                      dense
                      label="Branch"
                      outlined
                      v-model="newItem.branchId"
                    />
                    <v-text-field
                      label="Customer Ref"
                      outlined
                      dense
                      style="margin-top: -15px;"
                      v-model="newItem.customerRef"
                    /> 
                  </div>
                </div>
                <v-btn small @click="createItem" color="success"><v-icon left>mdi-plus</v-icon>Create Item</v-btn>
            </div>
            <div v-if="data.metadata">
              <h2>Items ({{data.metadata.softItems.length}})</h2>
              <div class="d-flex flex-row justify-end flex-wrap">
                <v-btn v-if="data.metadata.softItems && data.metadata.softItems.length > 0" color="warning" text class="mb-3" small @click="toggleHasNoteAll(true)">Show All Notes</v-btn>
                <v-btn v-if="data.metadata.softItems && data.metadata.softItems.length > 0" color="warning" text class="mb-3 ml-3" small @click="toggleHasNoteAll(false)">Hide All Notes</v-btn>
                <confirmedActionButton
                  v-if="data.metadata.softItems && data.metadata.softItems.length > 0"
                  color="info"   
                  @cb="bulkStatus('ORDER PLACED')"
                  :buttonText="'All Ordered'"
                  text
                  micro
                  small
                  class="mb-3 ml-3"
                />
                <confirmedActionButton
                  v-if="data.metadata.softItems && data.metadata.softItems.length > 0"
                  color="info"   
                  @cb="bulkStatus('ARRIVED')"
                  :buttonText="'All Arrived'"
                  text
                  micro
                  small
                  class="mb-3 ml-3"
                />
                <confirmedActionButton
                  v-if="data.metadata.softItems && data.metadata.softItems.length > 0"
                  color="info"   
                  @cb="bulkStatus('COLLECTED')"
                  :buttonText="'All Collected'"
                  text
                  micro
                  small
                  class="mb-3 ml-3"
                />
              </div>
              <div style="border:1px solid grey; border-radius: 7px; padding: 15px;" class="d-flex flex-column align-baseline justify-space-between mb-2" v-for="(item,index) in data.metadata.softItems" :key="index">
                <div class="d-flex flex-row align-baseline justify-space-between mb-2">
                  <div class="d-flex flex-row">
                    <confirmedActionButton
                      color="error"   
                      @cb="deleteItem(item.id)"
                      fab
                      xsmall
                      fabIcon="mdi-close"
                      :dialogText="'This will remove the item, are you sure you wish to proceed?'"
                    />
                    <div style="width: 300px;" class="d-flex flex-column mx-4" >
                      <h3 v-if="item.status=='ARRIVED'" style="background-color: yellow; color: black;"  class="ml-4 mr-4">Style No: {{ item.styleNo }}</h3>
                      <h3 v-else class="ml-4 mr-4">
                        <span class="d-flex flex-column">
                          <div>
                            <span style="color: grey;">STYLE: </span>
                            <b>{{ item.styleNo }}</b>
                          </div>
                          <div>
                            <span style="color: grey;">COLOUR: </span>
                            <b>{{ item.colour }}</b> 
                            <span class="ml-4" style="color: grey;">SIZE: </span>
                            <b>{{ item.size }}</b>
                          </div>
                        </span>
                      </h3>
                      <router-link :to="'/suppliers/view/'+item.Asset.Supplier.id" v-if="item.Asset.Supplier" class="ml-4 mr-4">SUPPLIER: {{item.Asset.Supplier.name }}</router-link>
                      <div v-else class="d-flex flex-row ml-4 mr-4">
                        <v-autocomplete
                          :items="suppliers"
                          :item-text="x => x.name"
                          item-value="id"
                          label="Link Supplier"
                          dense
                          clearable
                          outlined
                          id="supplierAutocorrect"
                          v-model="selectedSupplier"  
                        >
                          <template v-slot:no-data>
                              <v-btn text block @click="createLinkSupplier(item.id)"><v-icon left>mdi-plus</v-icon>Create Supplier</v-btn>
                          </template>
                        </v-autocomplete>
                        <v-btn class="ml-2" fab color="success" x-small @click="linkSupplier(item.id)"><v-icon>mdi-content-save</v-icon></v-btn>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <span class="d-flex flex-row">
                      <v-select
                        :disabled="!item.Asset.Supplier"
                        :items="specialOrderStatuses"
                        dense
                        label="Status"
                        outlined
                        v-model="item.status"
                        @change="saveItem(item.id)"
                        :loading="saveItemLoading"
                      />
                      <v-select
                        :items="getLocations"
                        item-value="id"
                        item-text="name"
                        dense
                        label="Branch"
                        outlined
                        v-model="item.branchId"
                        @change="saveItem(item.id)"
                      /> 
                    </span>
                    <v-text-field
                      label="Customer Ref"
                      outlined
                      dense
                      style="margin-top: -15px;"
                      v-model="item.customerRef"
                      @change="saveItem(item.id)"
                    />  
                    <!-- <v-text-field
                      label="Customer Ref"
                      outlined
                      dense
                      v-model="item.metadata.refName"
                      @change="saveItem(index)"
                    /> -->
                    <!-- <v-btn @click="saveItem(index)" class="ml-4" fab x-small color="success"><v-icon>mdi-content-save</v-icon></v-btn> -->
                  </div>
                </div>
                <v-btn v-if="!item.hasNote" color="info" small @click="toggleHasNote(true, item.id)">Show Notes</v-btn>
                <span style="width: 100%; border: 1px solid grey; border-radius: 10px; padding: 10px;" v-else>
                  <span class="d-flex flex-row align-baseline justify-baseline mb-2">
                    <h2>
                      <span>Notes</span>
                    <v-btn class="ml-4" color="warning" text small @click="toggleHasNote(false, item.id)">Hide</v-btn>
                    </h2>
                  </span>
                  <span class="d-flex flex-column align-end">
                    <div class="d-flex flex-column mb-2" style="width: 400px; padding: 20px; border-radius: 10px; border: 1px solid white;" v-for="(note, index) of item.notes" :key="index">
                      <div>{{ note.value }}</div>
                      <div style="font-size: 12px;">{{ lookupUsername(note.createdBy) }} at {{ helpers.customFormatDate(note.createdAt) }}</div>
                    </div>
                  </span>
                  <div class="d-flex flex-row mt-3">
                    <v-text-field label="New Note" placeholder="New Note" dense outlined v-model="item.tempNote"/>
                    <v-btn fab color="success" x-small @click="commitNote(item.id)"><v-icon>mdi-content-save</v-icon></v-btn>
                  </div>
                </span>
              </div>
            </div>
          </span>
          <!-- <div v-for="(item, index) in fakeItems" :key="index">
            <div class="d-flex flex-column" style="border: 1px solid grey; padding: 10px; border-radius: 10px;">
              <span>
                Status: {{ item.status }}
                {{index+1}}. {{ item.Asset.styleNo }} - {{ item.color }} 
              </span>
              <span>
                Supplier: {{ item.Asset.Supplier.name }}
              </span>
            </div>
          </div> -->
          <span></span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <!-- <v-btn @click="create" :disabled="!this.data.name">Create</v-btn> -->
        </v-col>
      </v-row>
    </v-container>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>
<script>
  import axios from 'axios';
  import confirmedActionButton from "../../components/confirmedActionButton.vue"
  import helpers from '../../plugins/helpers';
// import { color } from 'echarts';
  import {mapGetters} from "vuex";
  export default {
    components: {
      confirmedActionButton
    },
    data () {
      return {
        helpers: helpers,
        loader: false,
        snackObj: {
          color: '',
          text: ''
        },
        max25chars: v => v.length <= 25 || 'Input too long!',
        data: {},
        customers: [],
        assets: [],
        customerResults: [],
        assetResults: [],
        customerSearchField: {
          loading: false,
          name: "",
          phone: "",
        },
        assetSearchField: {
          value: '',
          loading: false,
        },
        suppliers: [],
        customersSearchIndex: [],
        assetsSearchIndex: [],
        selectedSupplier: '',
        enteredSupplierData: '',
        newItem: {},
        saveItemLoading: false,
        singular: "Special Order",
        singularLower: "specialorder",
        plural: "SpecialOrders",
        pluralLower: "specialorders",
        // itemStatuses: ["NEW","ORDER PLACED","ARRIVED","COLLECTED"],
      }
    },
    async mounted(){
      try{
        let res;
        res = await axios.get(`${this.getEndpoint}/api/customers`)
        if(res.data.error) throw res.data.error;
        this.customers = res.data.data; 
        
        for(let i = 0; i < this.customers.length; i++){
          let obj = {}
          obj.name = (this.customers[i].fullName).trim().replace(" ", '').toUpperCase()
          obj.phone = (this.customers[i].phone)?.trim().replace(" ", '').replace("-", '')
          this.customersSearchIndex.push(obj)
        }

        res = await axios.get(`${this.getEndpoint}/api/assets`)
        if(res.data.error) throw res.data.error;
        this.assets = res.data.data;

        for(let i = 0; i < this.assets.length; i++){
          let obj = {}
          obj.styleNo = (this.assets[i].styleNo).trim().replace(" ", '').toUpperCase()
          this.assetsSearchIndex.push(obj)
        }

        res = await axios.get(`${this.getEndpoint}/api/suppliers`)
        if(res.data.error) throw res.data.error;
        this.suppliers = res.data.data;

        await this.getAllData()
        
      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.loader = false;
      }
    },
    computed: {
      ...mapGetters(['getEndpoint', 'lookupUsername', 'specialOrderStatuses', 'getLocations'])
    },
    methods: {
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.color = color;

        this.$refs.snackbar.openDialog();
      },
      async bulkStatus(status){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/specialOrders/bulkStatus/${this.$route.params.id}`, {status: status})
          if(res.data.error) throw res.data.error
          await this.getAllData()
        } catch (error) {
          this.snack(error)
          console.error(error)
        }
      },
      async toggleHasNoteAll(val){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/specialOrders/toggleNoteAll/${this.$route.params.id}`, {hasNote: val})
          if(res.data.error) throw res.data.error
          await this.getAllData()
        } catch (error) {
          this.snack(error)
          console.error(error)
        }
      },
      async linkSupplier(id){
        try {
          let index = this.data.metadata.softItems.findIndex(x=>x.id===id)
          let obj = {
            supplierId: this.selectedSupplier, 
            assetId: this.data.metadata.softItems[index].assetId
          }
          await axios.post(`${this.getEndpoint}/api/specialOrders/linkSupplier`, obj)
          
          await this.getAllData()
          
        } catch (error) {
          console.error(error)
        }
      },
      async linkSupplierNewAsset(){
        try {

          let check = this.hasKeysWithValues(["supplierId", "id"], this.newItem)
          if(check.length > 0){
            throw `Can't create item. Missing values: ${check.map(x=>" "+x)}`;
          }

          let obj = {
            supplierId: this.newItem.supplierId, 
            assetId: this.newItem.id
          }
          await axios.post(`${this.getEndpoint}/api/specialOrders/linkSupplier`, obj)
          
          this.newItem.assetSupplier = obj.supplierId

          this.$forceUpdate()

          this.snack("Supplier linked", 'success')
          
        } catch (error) {
          this.snack(error)
          console.error(error)
        }
      },
      async createLinkSupplier(id){
        try {
          let index = this.data.metadata.softItems.findIndex(x=>x.id===id)
          let obj = {
            supplierName: document.getElementById("supplierAutocorrect").value, 
            assetId: this.data.metadata.softItems[index].assetId
          }
          let res = await axios.post(`${this.getEndpoint}/api/specialOrders/createLinkSupplier`, obj)
          if(res.data.error) throw res.data.error
          this.snack('Created and Linked Supplier',"success")
          await this.getAllData()
          
        } catch (error) {
          this.snack(error)
          console.error(error)
        }
      },

      async createLinkSupplierNewAsset(){
        try {

          let obj = {
            supplierName: document.getElementById("supplierAssetAutocorrect").value, 
            assetId: this.newItem.id
          }

          let res = await axios.post(`${this.getEndpoint}/api/specialOrders/createLinkSupplier`, obj)
          if(res.data.error) throw res.data.error
          this.newItem.assetSupplier = obj.supplierName
          this.snack('Created and Linked Supplier',"success")
          this.$forceUpdate()
          
        } catch (error) {
          this.snack(error)
          console.error(error)
        }
      },
      async createAsset(){
        try {
          let obj = {
            styleNo: document.getElementById("assetAutocorrect").value,
          }
          let res = await axios.post(`${this.getEndpoint}/api/assets/`, obj)
          if(res.data.error) throw res.data.error
          console.log(res.data.data.data)
          this.assets.push(res.data.data.data)
          this.newItem.id = res.data.data.data.id
          this.newItem.styleNo = res.data.data.data.styleNo

          this.$forceUpdate()
          
        } catch (error) {
          console.error(error)
        }
      },
      async selectCustomer(id){
        try {
          let c = this.customers.find(x=>x.id===id)
          this.data.customerId = c.id
          this.data.customerName = c.fullName
          this.data.customerPhone = c.phone
          console.log("Customer Selected")
          this.$forceUpdate()
          
          let obj = {customerId: this.data.customerId}
          await axios.post(`${this.getEndpoint}/api/specialOrders/setCustomer/${this.$route.params.id}`, obj)
          
          this.customerResults = []
        } catch (error) {
          console.error(error)
        }
      },
      clearCustomer(){
        this.customerSearchField.value = ""
        this.data.customerId = null
        this.data.customerName = null
        this.data.customerPhone = null
        this.$forceUpdate()
      },
      async selectCustomerChanged(){
        try {
           //
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      }, 
      clearCustomerSearches(){
        if(this.data.metadata && this.data.metadata.softItems && this.data.metadata.softItems.length > 0){
          this.snack("Cannot clear customer with items.", 'error')
          return
        }
        this.customerSearchField.name = ''
        this.customerSearchField.phone = ''
        this.clearCustomer()
      },
      searchCustomers(from){
        this.customerResults = []
        let searchTerm = ''
        if(from==="name"){
          searchTerm = this.customerSearchField.name.trim().replace(" ", '').replace("-", "").toUpperCase()
        }else if(from==="phone"){
          searchTerm = this.customerSearchField.phone.trim().replace(" ", '').replace("-", "").toUpperCase()
        }

        if(!searchTerm || searchTerm == ""){
          this.customerResults = []
          return
        }
        let tempArr = []
        for(let i = 0; i < this.customersSearchIndex.length; i++){
          if(this.customersSearchIndex[i]?.name?.includes(searchTerm)||this.customersSearchIndex[i]?.phone?.includes(searchTerm)){
            tempArr.push(this.customers[i])
          }
        }
        this.customerResults = tempArr.slice(0,10)
      },
      async updateCustomerRef(){
        try {
          let obj = {
            customerRef: this.data.customerRef,
          }
          let res = await axios.put(`${this.getEndpoint}/api/specialOrders/updateCustomerRef/${this.$route.params.id}`, obj)
          if(res.data.id){
            this.snack(`${this.singular} Created 🎉`, "success");
          }
          await this.getAllData()
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      async updateNotes(){
        try {
          let obj = {
            notes: this.data.notes,
          }
          let res = await axios.put(`${this.getEndpoint}/api/specialOrders/updateNotes/${this.$route.params.id}`, obj)
          if(res.data.id){
            this.snack(`${this.singular} Created 🎉`, "success");
          }
          await this.getAllData()
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },      
      async updateDueDate(){
        try {
          let obj = {
            dueAt: this.data.dueAt,
          }

          let res = await axios.put(`${this.getEndpoint}/api/specialOrders/updateDueDate/${this.$route.params.id}`, obj)
          if(res.data.id){
            this.snack(`${this.singular} Created 🎉`, "success");
          }
          await this.getAllData()
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      async createCustomer(){
        try {
          let obj = {
            name: this.customerSearchField.name,
            phone: this.customerSearchField.phone,
          }
          let res = await axios.post(`${this.getEndpoint}/api/specialOrders/createSetCustomer/${this.$route.params.id}`, obj)
          if(res.data.id){
            this.snack(`${this.singular} Created 🎉`, "success");
          }
          await this.getAllData()
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      searchAssets(){
        this.assetResults = []
        let searchTerm = this.assetSearchField.value.trim().replace(" ", '').replace("-", "").toUpperCase()

        if(!searchTerm || searchTerm == ""){
          this.assetResults = []
          return
        }

        let temp = []

        for(let i = 0; i < this.assetsSearchIndex.length; i++){
          if(this.assetsSearchIndex[i]?.styleNo?.includes(searchTerm)||this.assetsSearchIndex[i]?.styleNo?.includes(searchTerm)){
            temp.push(this.assets[i])
          }
        }

        this.assetResults = temp.slice(0,10)
      },
      selectAsset(id){
        let a = this.assets.find(x=>x.id===id)
        this.data.selectedAsset = a
        this.$forceUpdate()
        this.assetResults = []
      }, 
      async getAllData(){
        try {
          let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
          if(res.data.error) throw res.data.error
          this.data = res.data

          if(this.data.Customer){
            this.data.customerName = this.data.Customer.firstName + " " + this.data.Customer.lastName
            this.data.customerPhone = this.data.Customer.phone
          }
          this.data.dueAt = this.helpers.parseISODate(this.data.dueAt);
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      async create(){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}`, this.data)
          if(res.data.id){
            this.snack(`${this.singular} Created 🎉`, "success");
            setTimeout(()=>{
              this.$router.push({ path: `/${this.pluralLower}/view/${res.data.id}`})
            }, 3000)
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      clearAssetSearches(){
        this.assetSearchField.value = ''
        this.clearAsset()
      },
      clearAsset(){
        this.assetSearchField.value = ""
        this.data.selectedAsset = null
        this.$forceUpdate()
      },
      hasKeysWithValues(keys, obj) {
        return keys.filter(key => (!Object.prototype.hasOwnProperty.call(obj, key) || !(obj[key])));
      },
      async updateStyleNo(){
        try {
          if(!this.newItem.id){
            this.newItem.assetSupplier = null
            return
          }

          let asset = this.assets.find(x=>x.id === this.newItem.id)
          this.newItem.styleNo = asset.styleNo
          
          if(asset.supplierId){
            this.newItem.assetSupplier = asset.supplierId
          }


          this.$forceUpdate()
        } catch (error) {
          console.error(error)
          this.snack(error)
        }
      },
      async createItem(){
        try {
          let check = this.hasKeysWithValues(["id", "colour", "size", "branchId", "styleNo", "customerRef"], this.newItem)

          if(check.length > 0){
            console.log("KEYS WITH VALUES ERROR:", this.newItem)
            throw `Frontend: Can't create item. Missing values: ${check.map(x=>" "+x)}`;
          }

          let obj = {
            assetId: this.newItem.id,
            colour: this.newItem.colour,
            size: this.newItem.size,
            branchId: this.newItem.branchId,
            styleNo: this.newItem.styleNo,
            customerRef: this.newItem.customerRef
          }
          let res = await axios.post(`${this.getEndpoint}/api/specialOrders/softCreateItem/${this.$route.params.id}`, obj)
          if(res.data.error) throw res.data.error
          if(res.data.success){
            await this.getAllData()
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      async deleteItem(id){
        try {
          let res = await axios.delete(`${this.getEndpoint}/api/specialOrders/softDeleteItem/${this.$route.params.id}/${id}`)
          if(res.data.error){
            throw res.data.error
          }
          if(res.data.success){
            await this.getAllData()
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      async saveItem(id){
        try {
          this.saveItemLoading = true
          let index = this.data.metadata.softItems.findIndex(x=>x.id===id)
          let obj = this.data.metadata.softItems[index]
          let res = await axios.post(`${this.getEndpoint}/api/specialOrders/softSaveItem/${this.$route.params.id}/${id}`, obj)
          if(res.data.error) throw res.data.error
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.saveItemLoading = false
          await this.getAllData()
        }
      },
      keypressCommitNote(e,index){
        console.log(e,index)
      },
      async commitNote(id){
        try {
          this.saveItemLoading = true
          let index = this.data.metadata.softItems.findIndex(x=>x.id===id)
          let obj = this.data.metadata.softItems[index]
          let res = await axios.post(`${this.getEndpoint}/api/specialOrders/commitNote/${this.$route.params.id}/${id}`, obj)
          if(res.data.error){
            throw res.data.error
          }
          if(res.data.success){
            await this.getAllData()
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.saveItemLoading = false
        }
      },
      async toggleHasNote(val, id){
        try {
          let index = this.data.metadata.softItems.findIndex(x=>x.id===id)
          let obj = this.data.metadata.softItems[index]
          obj.hasNote = val
          let res = await axios.post(`${this.getEndpoint}/api/specialOrders/toggleNote/${this.$route.params.id}/${id}`, {hasNote: val})
          if(res.data.error) throw res.data.error
          await this.getAllData()
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      }
    },
    
  }
</script>
